function getLastToken (input: string): string {
  const tokens: string[] = input.split('/')

  return tokens.length ? tokens[tokens.length - 1] : ''
}

export default getLastToken
